import RoutingsPage from './RoutingsPage';

const IntermediateRoutingsPage = () => (
  <RoutingsPage
    routingType="INTERMEDIATE_ROUTING"
    materialType="INTERMEDIATE_PRODUCT"
    titleKey="headers.intermediateRoutings"
    entityName="routing-intermediate"
  />
);

export default IntermediateRoutingsPage;
